"use client";

import { useCallback, useContext } from "react";
import { TranslationScopes } from "@finbackoffice/enums";
import { I18nContext } from "contexts";
import { IUserInterfaceTranslationResponse } from "@finbackoffice/clientbff-client";
import { useParams } from "next/navigation";

export const useSetI18nextResources = (): {
    setTranslationResources: (
        translations: Partial<Record<TranslationScopes, IUserInterfaceTranslationResponse>>,
    ) => void;
} => {
    const { lang: locale } = useParams();
    const { i18n } = useContext(I18nContext);

    const setTranslationResources = useCallback(
        (translations: Partial<Record<TranslationScopes, IUserInterfaceTranslationResponse>>) => {
            Object.keys(translations).forEach((scope) => {
                i18n.addResourceBundle(
                    locale as string,
                    scope,
                    translations[scope as TranslationScopes],
                    true,
                    true,
                );
            });
        },
        [i18n, locale],
    );

    return { setTranslationResources };
};
